module.exports = __webpack_public_path__ + "static/processing_visual-eb513a8689123edc20159a64d21827e7.svg";